import React from "react";
import { Stack } from "@mui/material";
import {
  CrmCompanyAvatarAndTitleData,
  CrmCompanyAvatarAndTitleForm,
  CrmCompanyDetailsData,
  CrmCompanyDetailsForm,
} from "./boxes/CrmCompanyDetailsBox.js";
import { CrmCompanyCustomFieldsBox } from "./boxes/CrmCompanyCustomFieldsBox.js";
import { CrmCompanyPaymentInformationBox } from "./boxes/CrmCompanyPaymentInformationBox.js";
import { CrmCompanyRegistrationDetailsBox } from "./boxes/CrmCompanyRegistrationDetailsBox.js";
import { CardContainer } from "@msys/ui";
import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useCrmCompanyEditForm_CrmCompanyQuery } from "./CrmCompanyEditForm.generated.js";
import { RestrictedByOrganisationPermissionWithDebug } from "../../auth/RestrictedByOrganisationPermission.js";

interface Props {
  crmCompanyId: string;
  onCrmCompanyChange?: (crmCompany: { id: string; title: string }) => void;
}

export const CrmCompanyEditForm = ({
  crmCompanyId,
  onCrmCompanyChange,
}: Props) => {
  const client = useApolloClient();
  const query = useCrmCompanyEditForm_CrmCompanyQuery({
    client,
    variables: { crmCompanyId },
  });
  const crmCompany = getDataOrNull(query.data?.crmCompany)?.crmCompany;
  return crmCompany ? (
    <Stack spacing={1}>
      <CardContainer>
        <RestrictedByOrganisationPermissionWithDebug
          permission="crm_record_update"
          otherwise={
            <Stack
              direction="column"
              spacing={1}
              sx={{
                p: 1,
              }}
            >
              <CrmCompanyAvatarAndTitleData crmCompany={crmCompany} />
              <CrmCompanyDetailsData crmCompany={crmCompany} />
            </Stack>
          }
        >
          <Stack
            direction="column"
            spacing={1}
            sx={{
              p: 1,
            }}
          >
            <CrmCompanyAvatarAndTitleForm crmCompany={crmCompany} />
            <CrmCompanyDetailsForm
              crmCompany={crmCompany}
              onChange={({ title }) => {
                onCrmCompanyChange?.({ id: crmCompany.id, title });
              }}
            />
          </Stack>
        </RestrictedByOrganisationPermissionWithDebug>
      </CardContainer>
      <CrmCompanyCustomFieldsBox crmCompany={crmCompany} />
      <CrmCompanyPaymentInformationBox crmCompany={crmCompany} />
      <CrmCompanyRegistrationDetailsBox crmCompany={crmCompany} />
    </Stack>
  ) : null;
};
